// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html .cog-cognito input::-webkit-date-and-time-value,:root:root:root:root:root .cog-cognito input::-webkit-date-and-time-value{text-align:start}html .cog-date--time .cog-i-clock.cog-i-clock g,:root:root:root:root:root .cog-date--time .cog-i-clock.cog-i-clock g{stroke-width:calc(var(--icon-weight)*1.2px)}html .cog-time-popper li,:root:root:root:root:root .cog-time-popper li{animation:cog-fade-in .4 .6s}", ""]);
// Exports
module.exports = exports;
